import React from "react";
import type { ReactNode } from "react";

import reducer from "./reducer";
import initialState from "./initialState";
import type { SidebarContextValue, SidebarState } from "./types";

export const SidebarContext = React.createContext<
  SidebarContextValue | undefined
>(undefined);

export type SidebarContextProviderProps = {
  children?: ReactNode | undefined;
  initialState?: Partial<SidebarState> | undefined;
};

export const SidebarContextProvider = ({
  children,
  initialState: initialStateOverride,
}: SidebarContextProviderProps) => {
  return (
    <SidebarContext.Provider
      value={React.useReducer(reducer, {
        ...initialState(),
        ...initialStateOverride,
      })}
    >
      {children}
    </SidebarContext.Provider>
  );
};
